import { reactive } from 'vue';
import Api from '../api/Documents';

const state = reactive({
    categories: [],
    loading: false,
});

export default {
    async init() {
        console.log(state.categories)
        state.loading = true;
        const res = await Api.Get();
        state.loading = false;
        state.categories = res.data.categories;
    },
    async refresh() {
        const res = await Api.Get();
        state.categories = res.data.categories;
    },
    getCategories() {
        return state.categories;
    },
    isLoading() {
        return state.loading;
    },
}